import * as Types from '../../constants/actionTypes';
const initState = {
    standardReports: [],
    serviceDocuments: [],
    otherDocuments: [],
    documentTypes: [],
    documentTags: [],
    reportAssets: [],
    portalUserCountries: [],
    savedFilters: [],
    documentFilterInfo: {},
    standardReportTotal: 0,
    serviceDocumentTotal: 0,
    otherDocumentTotal: 0,
    tagsDetails: []
}

export default (state = initState, action) => {
    switch (action.type) {
        case Types.STANDARD_REPORTS_LIST:
            return {
                ...state,
                standardReports: action.data,
                standardReportTotal: action.total
            }
        case Types.SERVICE_DOCS_LIST:
            return {
                ...state,
                serviceDocuments: action.data,
                serviceDocumentTotal: action.total
            }
        case Types.OTHER_DOCS_LIST:
            return {
                ...state,
                otherDocuments: action.data,
                otherDocumentTotal: action.total,
                tagDetails: action.tagDetails,
            }
        case Types.DOCUMENTS_ERROR:
            return {
                ...state,
                documentError: action.error
            }
        case Types.LIST_DOC_TYPES:
            return {
                ...state,
                documentTypes: action.data,
            }
        case Types.LIST_DOC_TAGS:
            return {
                ...state,
                documentTags: action.data,
            }
        case Types.LIST_REPORT_ASSETS:
            return {
                ...state,
                reportAssets: action.data,
            }  
        case Types.LIST_REPORT_ASSETS_BY_REQUEST_ID:
            return {
                ...state,
                requestReportAssets: action.data,
            } 
        case Types.DOCUMENT_TYPES_ERROR:
            return {
                ...state,
                documentTypesError: action.error
            }
        case Types.GET_USER_SAVED_FILTERS:
            return {
                ...state,
                savedFilters: action.userSavedFilters
            }
        case Types.GET_DOCUMENT_FILTER_INFO:
            return {
                ...state,
                documentFilterInfo: action.documentFilterInfo
            }
        case Types.PORTAL_USER_COUNTRIES_LIST:
            return {
                ...state,
                portalUserCountries: action.payload
            }
        case Types.REQUEST_IDS_SUCCESS:
            return {
                ...state,
                requestIds: action.requestIds
            }
        default:
            return state
    }
}
